import { Form, Input, Select } from 'antd';
import { FC, useEffect, useState } from 'react';
import ArrowIcon from '../../../../../assets/images/catalogue/arrowIcon';
import { v4 as uuid } from 'uuid';
import { IProductDetailId } from '../../../../../types/products';
import { getSpecsLists } from '../../../../../services/cataloge';
import { ISpecs } from '../../../../../types/category';
import GeneralInfoSkeleton from '../../../../../components/formLoaders/generalInfo/GeneralInfoSkeleton';
import errorMessage from '../../../../../utils/errorMessage';
interface ILaptop {
  productDataDetail?: IProductDetailId;
  setVerifySpecs: (isVerify: boolean) => void;
}

const Laptop: FC<ILaptop> = ({ productDataDetail, setVerifySpecs }: ILaptop) => {
  const [hardDriveList, setHardDriveList] = useState<ISpecs>();
  const [ramList, setRamList] = useState<ISpecs>();
  const [processorList, setProcessorList] = useState<ISpecs>();
  const [sofwareList, setSoftwareList] = useState<ISpecs>();
  const [loading, setLoading] = useState<boolean>(false);
  const { Option } = Select;
  const hardDrive = Form.useWatch('hardDrive');
  const processor = Form.useWatch('processor');
  const displayInches = Form.useWatch('displayInches');
  const ram = Form.useWatch('ram');
  const software = Form.useWatch('software');

  const getLaptopSpecs = async () => {
    setLoading(true);
    try {
      const hardDriveData = await getSpecsLists('almacenamiento');
      const ramData = await getSpecsLists('memoria');
      const processorData = await getSpecsLists('procesador');
      const softwareData = await getSpecsLists('software');
      setHardDriveList(hardDriveData);
      setRamList(ramData);
      setProcessorList(processorData);
      setSoftwareList(softwareData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      errorMessage();
    }
  };
  const verifyGroup = () => {
    if (hardDrive && processor && displayInches && ram && software) {
      setVerifySpecs(true);
    } else {
      setVerifySpecs(false);
    }
  };
  useEffect(() => {
    getLaptopSpecs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    verifyGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hardDrive, processor, displayInches, ram, software]);
  return (
    <>
      {loading ? (
        <GeneralInfoSkeleton />
      ) : (
        <>
          <div className="firstSection">
            <div className="mediumItem">
              <div className="titleForm">Procesador</div>
              <div className="customSelectAnt">
                <Form.Item>
                  <Form.Item
                    initialValue={productDataDetail?.processor}
                    noStyle
                    name="processor"
                    rules={[{ required: true, message: 'campo requerido' }]}
                  >
                    <Select
                      className="customStyle"
                      placeholder="Ej. M2"
                      suffixIcon={<ArrowIcon className="rotateIcon" />}
                    >
                      {processorList &&
                        processorList.value &&
                        processorList.value.map(item => {
                          return (
                            <Option key={uuid()} value={item}>
                              {item}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Form.Item>
              </div>
            </div>
            <div className="mediumItem">
              <div className="titleForm">Almacenamiento</div>
              <div className="customSelectAnt">
                <Form.Item>
                  <Form.Item
                    noStyle
                    initialValue={productDataDetail?.hardDrive}
                    name="hardDrive"
                    rules={[{ required: true, message: 'campo requerido' }]}
                  >
                    <Select
                      className="customStyle"
                      placeholder="Ej. 515 GB SSD"
                      suffixIcon={<ArrowIcon className="rotateIcon" />}
                    >
                      {hardDriveList &&
                        hardDriveList.value &&
                        hardDriveList.value.map(item => {
                          return (
                            <Option key={uuid()} value={item}>
                              {item}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Form.Item>
              </div>
            </div>
            <div className="mediumItem">
              <div className="titleForm">Memoria</div>
              <div className="customSelectAnt">
                <Form.Item>
                  <Form.Item
                    noStyle
                    initialValue={productDataDetail?.ram}
                    name="ram"
                    rules={[{ required: true, message: 'campo requerido' }]}
                  >
                    <Select
                      className="customStyle"
                      placeholder="Ej. 16 GB RAM"
                      suffixIcon={<ArrowIcon className="rotateIcon" />}
                    >
                      {ramList &&
                        ramList.value &&
                        ramList.value.map(item => {
                          return (
                            <Option key={uuid()} value={item}>
                              {item}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Form.Item>
              </div>
            </div>
            <div className="smallItem noMargin">
              <div className="titleForm">Pantalla</div>
              <Form.Item
                name="displayInches"
                initialValue={productDataDetail?.displayInches}
                rules={[{ required: true, message: 'campo requerido' }]}
              >
                <Input className="inputTabs" placeholder="Ej. 15’’" />
              </Form.Item>
            </div>
          </div>
          <div className="secondSection">
            <div className="mediumItem">
              <div className="titleForm">Sistema operativo</div>
              <div className="customSelectAnt">
                <Form.Item>
                  <Form.Item
                    noStyle
                    initialValue={productDataDetail?.software}
                    name="software"
                    rules={[{ required: true, message: 'campo requerido' }]}
                  >
                    <Select
                      className="customStyle"
                      placeholder="Ej. Windows"
                      suffixIcon={<ArrowIcon className="rotateIcon" />}
                    >
                      {sofwareList &&
                        sofwareList.value &&
                        sofwareList.value.map(item => {
                          return (
                            <Option key={uuid()} value={item}>
                              {item}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Form.Item>
              </div>
            </div>
            <div className="largeItem">
              <div className="titleForm">{'Accesorios (opcional)'}</div>
              <Form.Item initialValue={productDataDetail?.inBoxAccessories} name="inBoxAccessories">
                <Input className="inputTabs" placeholder="Ej. Cargador" />
              </Form.Item>
            </div>
            <div className="mediumItem noMargin">
              <div className="titleForm">{'Color (opcional)'}</div>
              <Form.Item initialValue={productDataDetail?.color} name="color">
                <Input className="inputTabs" placeholder="Ej. Negro" />
              </Form.Item>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Laptop;
